import { render, staticRenderFns } from "./CeldaBuenoRegularNA.vue?vue&type=template&id=c7a33574&scoped=true&"
import script from "./CeldaBuenoRegularNA.vue?vue&type=script&lang=js&"
export * from "./CeldaBuenoRegularNA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a33574",
  null
  
)

export default component.exports